import { render, staticRenderFns } from "./_BroadcastItem.vue?vue&type=template&id=8e28174a&scoped=true&"
import script from "./_BroadcastItem.vue?vue&type=script&lang=js&"
export * from "./_BroadcastItem.vue?vue&type=script&lang=js&"
import style0 from "./_BroadcastItem.vue?vue&type=style&index=0&id=8e28174a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e28174a",
  null
  
)

export default component.exports